interface LoadingScreenProps {
    message?: string; // Optional loading message (kept for compatibility but not displayed)
}

export function LoadingScreen({ message }: LoadingScreenProps = {}) {
    // Detect dark mode from the root <html> class set by ThemeContext.
    // ThemeContext only applies 'dark' on /dashboard routes, so public/onboarding
    // pages always use the light variant automatically.
    const isDark = typeof document !== 'undefined' &&
        document.documentElement.classList.contains('dark');

    return (
        <div
            className={`fixed inset-0 z-40 flex items-center justify-center ${isDark ? '' : 'bg-gradient-to-br from-sky-100 via-slate-50 to-indigo-100'}`}
            style={isDark ? { backgroundColor: '#020617' } : undefined}
        >
            <div className="flex flex-col items-center gap-6">
                <img
                    src="/deskbay-logo-text.png"
                    alt="Deskbay"
                    className="w-32 md:w-40 animate-slow-pulse"
                />
                {message && (
                    <p className={`text-sm font-medium animate-slow-pulse ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>{message}</p>
                )}
            </div>
        </div>
    );
}
